import * as React from 'react'
import { SVGProps } from 'react'

const IllustrationCases = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={433}
    aria-hidden='true'
    height={297.058}
    className='r-1qahzrx r-1t01tom'
    viewBox='0 0 430 295'
    {...props}
  >
    <defs>
      <linearGradient
        id='a'
        x1='50.002%'
        x2='50.002%'
        y1='100%'
        y2='-.002%'
      >
        <stop
          offset='0%'
          stopColor='gray'
          stopOpacity={0.25}
        />

        <stop
          offset='54%'
          stopColor='gray'
          stopOpacity={0.12}
        />

        <stop
          offset='100%'
          stopColor='gray'
          stopOpacity={0.1}
        />
      </linearGradient>

      <linearGradient
        id='b'
        x1='50.02%'
        x2='50.02%'
        y1='99.99%'
        y2='.002%'
      >
        <stop
          offset='0%'
          stopColor='gray'
          stopOpacity={0.25}
        />

        <stop
          offset='54%'
          stopColor='gray'
          stopOpacity={0.12}
        />

        <stop
          offset='100%'
          stopColor='gray'
          stopOpacity={0.1}
        />
      </linearGradient>
    </defs>

    <g
      fill='none'
      fillRule='evenodd'
    >
      <path
        fill='transparent'
        fillRule='nonzero'
        d='M41.98 223.046c-1.839 3.955.792 8.224-.12 12.307-1.153 5.153-7.76 9.164-14.877 11.724-7.116 2.559-15.064 4.113-22 6.87-3 1.19-6.128 3.384-4.568 5.402.54.7 1.55 1.19 2.54 1.65 20.206 9.343 45.18 14.419 70.134 14.256 26.393-.176 52.237-6.012 78.608-5.342 34.011.859 66.908 12.479 100.541 9.13 14.276-1.43 27.533-5.484 41.436-8.018 20.446-3.723 41.95-4.097 63.124-5.32 15.9-.92 34.07-3.303 41.667-12.26 5.493-6.476 3.188-15.03-4.55-20.513-7.738-5.484-20.099-7.829-31.517-6.764-6.14.571-12.241 2.053-18.38 1.465-3.565-.344-6.856-1.366-10.108-2.37-25.154-7.816-51.213-15.614-79.135-16.748-45.416-1.86-87.512 13.977-131.758 20.827-6.89 1.065-14.37 1.885-20.879.098-6.855-1.885-11.354-6.338-18.222-8.214-3.26-.894-6.894-1.151-10.099-2.122-8.809-2.67-4.713-6.342-16.94-3.864-6.389 1.305-12.841 3.396-14.898 7.806z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        fillRule='nonzero'
        d='M46.832 88.829s23.675 23.858 10.317 59.26C43.792 183.49 80.077 242.36 80.077 242.36s-.391-.056-1.109-.184c-48.648-8.652-72.807-64.69-45.77-106.308 10.05-15.493 18.304-33.648 13.634-47.04z'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M46.832 88.829s23.675 23.858 10.317 59.26C43.792 183.49 80.077 242.36 80.077 242.36s-.391-.056-1.109-.184c-48.648-8.652-72.807-64.69-45.77-106.308 10.05-15.493 18.304-33.648 13.634-47.04z'
        opacity={0.1}
      />

      <path
        stroke='#535461'
        d='M47.278 88.829s13.638 29.245 0 53.103c-13.638 23.857-2.34 90.81 33.895 100.429'
      />

      <path
        fill='currentColor'
        fillRule='nonzero'
        d='M4.388 185.635s27.297-4.368 29.786 20.216c2.488 24.584 52.484 27.995 52.484 27.995s-.326.224-.94.625C44.44 261.698 4.976 251.82 10.923 215.655c2.213-13.456 2.029-26.95-6.534-30.02z'
      />

      <path
        fill='#F5F5F5'
        fillRule='nonzero'
        d='M4.388 185.635s27.297-4.368 29.786 20.216c2.488 24.584 52.484 27.995 52.484 27.995s-.326.224-.94.625C44.44 261.698 4.976 251.82 10.923 215.655c2.213-13.456 2.029-26.95-6.534-30.02z'
        opacity={0.2}
      />

      <path
        stroke='#535461'
        d='M4.388 185.335S25.576 190 23.835 209.332c-1.742 19.33 31.463 42.502 62.823 24.135'
      />

      <path
        fill='currentColor'
        fillRule='nonzero'
        d='M289.592 242.36H65.816V101.99h28.618l11.774 14.605h183.384z'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M289.592 242.36H65.816V101.99h28.618l11.774 14.605h183.384z'
        opacity={0.1}
      />

      <path
        fill='#F1F1F4'
        fillRule='nonzero'
        d='m107.38 80.545 100.892-36.482 56.811 157.019-100.893 36.482z'
      />

      <path
        fill='#FFF'
        fillRule='nonzero'
        d='m126.434 91.121 28.508-10.308 2.426 6.705-28.508 10.308zm11.799 16.773 62.72-22.388 2.2 6.157-62.721 22.389zm4.7 13.158 62.72-22.388 2.2 6.157-62.72 22.388zm4.697 13.158 62.72-22.388 2.199 6.157-62.72 22.388zm4.7 13.154 62.72-22.389 2.199 6.157-62.72 22.389zm4.699 13.154 62.72-22.389 2.199 6.157-62.72 22.389zm4.7 13.157 62.72-22.388 2.2 6.157-62.72 22.389zm58.696 5.242 16.24-5.797 5.797 16.234-16.238 5.797z'
      />

      <path
        fill='url(#a)'
        fillRule='nonzero'
        d='m77.325 58.169 110.743.014.023 172.428-110.743-.015z'
        transform='rotate(-59.28 132.708 144.39)'
      />

      <path
        fill='#F1F1F4'
        fillRule='nonzero'
        d='m33.472 147.847 54.83-92.244 143.645 85.332-54.83 92.243z'
      />

      <path
        fill='#FFF'
        fillRule='nonzero'
        d='m54.818 143.935 15.493-26.064 6.134 3.644-15.493 26.064zm19.396 4.605 34.021-57.237 5.623 3.34-34.022 57.236zm12.013 7.137 34.022-57.235 5.622 3.34-34.021 57.235zm11.965 6.946 33.966-57.257 5.624 3.334-33.965 57.258zm12.058 7.324 34.022-57.236 5.622 3.34-34.021 57.236zm12.014 7.138 34.021-57.235 5.623 3.34-34.022 57.235zm12.018 7.139 34.021-57.236 5.622 3.34-34.021 57.235zm48.418-33.623 8.793-14.824 14.83 8.791-8.795 14.824z'
      />

      <path
        fill='url(#b)'
        fillRule='nonzero'
        d='M410.245 54.498c0-.212-.022-.413-.065-.605a7.095 7.095 0 0 1-.112-.664 19.475 19.475 0 0 0-.434-1.857 16.034 16.034 0 0 0-3.229-6.127l-.258-.292a15.582 15.582 0 0 0-.511-.536 10.48 10.48 0 0 0-.499-.467 17.576 17.576 0 0 0-.477-.407 9.602 9.602 0 0 0-.86-.63c-.266-.172-.361-.236-.512-.326a2.899 2.899 0 0 0-1.203-.39l-2.653-.258-3.585-.351-12.945-4.987-.512.18a29.5 29.5 0 0 1-.959-3.16 2.884 2.884 0 0 0 1.024-.742c.305-.236.548-.543.705-.896.326-.746-.297-2.341-.172-3.25.206-1.462.971-2.877 1.595-4.202 1.332-2.847 2.304-5.93 2.15-9.055-.156-3.126-1.596-6.295-4.257-8.044-1.376-.905-3.01-1.39-4.424-2.213-1.113-.643-2.094-1.479-3.155-2.203a18.262 18.262 0 0 0-17.855-1.265c-2.691 1.316-4.987 3.28-7.528 4.853-2.54 1.574-5.533 2.792-8.504 2.324a1.89 1.89 0 0 0-.09.365l-.25-.03c-.51 1.385.744 2.748 1.9 3.696 2.194 1.792 4.683 3.584 7.546 3.644 1.105.026 2.274-.206 3.28.245.218.1.424.227.61.377a14.04 14.04 0 0 0 4.476 14.08l-6.612-2.358s-.275.142-.705.408l-9.187-6.059s-18.414-6.65-23.53 3.658c-5.116 10.307 22.167 4.986 22.167 4.986l5.838 3.182a5.245 5.245 0 0 0 .64 3.468l15.908 9.75c-3.216.982-8.5 2.573-9.459 2.573-1.362 0-5.116 1.33-7.502 6.65-2.386 5.321-10.911 31.262-18.413 35.588-7.502 4.326-27.283 33.255-27.283 33.255l.09.228c-.352.091-.697.193-1.036.304-4.948 1.595-8.276 4.96-10.283 7.684a3.251 3.251 0 0 0-.333 3.234 3.267 3.267 0 0 0 2.637 1.91c7.807.978 12.072-2.572 14.123-5.282.133-.175.258-.347.374-.514.61.258 1.295.289 1.926.086l9.549-7.65s-7.472 7.29-3.092 13.931l-.33.459a105.48 105.48 0 0 0-16.015 34.498s-4.093 3.002-4.433 14.964c-.34 11.963-4.432 31.262-4.432 31.262s-2.73 22.948-1.023 29.932c0 0 .197.279.559.703-.13.15-.267.313-.43.48-1.488 1.596-4.175 3.795-7.309 3.14-4.776-1-4.776 7.314 2.046 7.983 4.394.429 13.023 2.375 18.616 3.704a3.92 3.92 0 0 0 3.51-.815 3.897 3.897 0 0 0 1.352-3.33c-.335-2.98-.941-6.587-2.046-9.155a15.42 15.42 0 0 0-.21-.467c.201-.185.4-.378.601-.583 0 0 0-14.634 2.386-18.626 0 0 6.48-30.263 6.14-37.912-.267-6.003 16.805-29.293 24.238-39.138l-.06-.373c1.9-2.512 3.104-4.056 3.104-4.056l5.796 36.248s2.781 7.984 6.19 12.297c0 0 14.665 27.604 16.367 36.248 1.29 6.556 3.956 10.432 5.16 11.924-.142.142-.289.283-.43.43-1.553 1.41-3.844 2.825-6.45 2.284-4.759-1.003-4.759 7.31 2.064 7.976 4.394.428 13.023 2.375 18.616 3.704a3.92 3.92 0 0 0 3.51-.815 3.897 3.897 0 0 0 1.352-3.331c-.387-3.46-1.148-7.765-2.618-10.29a7.303 7.303 0 0 0-.387-.605 3.603 3.603 0 0 0 1.354-.948s-8.873-20.97-8.873-26.626c0 0-3.753-21.619-16.367-29.585 0 0 1.195-27.034 4.785-42.084.089-.371.179-.736.27-1.093a102.78 102.78 0 0 0 9.949-2.054l.34-9.977 1.72 7.983 19.08-11.65s-.169-2.096-.491-5.312a347.34 347.34 0 0 0-.602-5.54 294.777 294.777 0 0 0-.83-6.482 200.838 200.838 0 0 0-.82-5.381 165.71 165.71 0 0 0-.345-1.977c-.154-.858-.318-1.715-.486-2.547a73.147 73.147 0 0 0-.257-1.226c-.09-.403-.178-.798-.267-1.184-.089-.385-.18-.764-.27-1.136l-.138-.549c-.095-.36-.19-.711-.284-1.054a18.892 18.892 0 0 1-.692-4.361 22.469 22.469 0 0 1 0-1.758c.023-.6.08-1.183.172-1.75.04-.285.088-.571.146-.857a19.648 19.648 0 0 1 1.68-5.03c.62-1.256 1.29-2.62 1.961-4.055.341-.718.685-1.451 1.032-2.2.347-.749.696-1.51 1.049-2.281 3.319-7.332 6.595-15.504 7.472-20.868.09-.566.16-1.098.193-1.6.041-.464.051-.931.03-1.397z'
      />

      <path
        fill='#F7BBC3'
        fillRule='nonzero'
        d='m354.311 33.53-11.38-7.37s-18.075-6.408-23.095 3.523c-5.02 9.931 21.751 4.806 21.751 4.806l11.38 6.087 1.344-7.045z'
      />

      <path
        fill='#F1F1F4'
        fillRule='nonzero'
        d='m231.396 92.85 57.559-90.567L429.988 91.86l-57.559 90.567z'
      />

      <path
        fill='#FFF'
        fillRule='nonzero'
        d='m252.85 89.576 16.263-25.59 6.022 3.825-16.263 25.59zm19.251 5.182 35.715-56.195 5.52 3.506-35.715 56.195zm11.796 7.491 35.715-56.196 5.52 3.506-35.715 56.196zm11.795 7.492 35.715-56.195 5.52 3.506-35.715 56.195zm12.509 9.355 35.964-55.926 5.493 3.53-35.963 55.926zm11.081 5.628 35.715-56.195 5.52 3.506-35.715 56.195zm12.538 9.506 35.962-55.926 5.494 3.53-35.963 55.926zm48.785-33.947 9.246-14.55 14.554 9.244-9.247 14.55z'
      />

      <path
        fill='#B77983'
        fillRule='nonzero'
        d='M386.97 264.182c-5.305-1.337-13.492-3.29-17.658-3.72-6.47-.669-6.47-9.016-1.943-8.013 2.456.542 4.625-.868 6.101-2.296.451-.445.874-.919 1.266-1.42a3.719 3.719 0 0 1 2.102-1.302c2.426-.547 7.475-1.372 10.583.356a4.666 4.666 0 0 1 1.681 1.892c1.396 2.557 2.103 6.876 2.485 10.353a3.928 3.928 0 0 1-1.265 3.312 3.656 3.656 0 0 1-3.351.838zm-83.375 3.288c-5.304-1.338-13.487-3.292-17.652-3.722-6.469-.669-6.469-9.019-1.942-8.016 2.942.66 5.51-1.554 6.918-3.152.172-.196.328-.383.462-.556a3.717 3.717 0 0 1 2.102-1.303c2.425-.547 7.473-1.372 10.579.356.908.508 1.635 1.62 2.215 3.04 1.046 2.579 1.622 6.2 1.942 9.192a3.932 3.932 0 0 1-1.263 3.324 3.653 3.653 0 0 1-3.36.836z'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M306.046 254.13c-7.727 8.258-14.352-.152-15.357-1.539.172-.196.328-.384.462-.558a3.718 3.718 0 0 1 2.104-1.309c2.427-.55 7.478-1.378 10.587.358.896.488 1.623 1.605 2.204 3.049zm83.367-4.694c-3.541 2.175-15.383 1.64-15.383 1.64a10.819 10.819 0 0 1-1.07-1.2c.474-.407.92-.84 1.332-1.3a4.03 4.03 0 0 1 2.213-1.199c2.554-.504 7.87-1.264 11.142.328a4.551 4.551 0 0 1 1.766 1.731z'
        opacity={0.1}
      />

      <path
        fill='#454A5F'
        fillRule='nonzero'
        d='M389.413 248.094c-2.31 2.972-15.5 2.315-15.5 2.315s-3.958-3.964-5.608-12.556c-1.65-8.592-15.831-36.01-15.831-36.01-3.297-4.293-5.938-12.224-5.938-12.224l-5.607-36.01s-27.045 35.679-26.715 43.28c.33 7.6-5.938 37.653-5.938 37.653-2.31 3.964-2.31 18.499-2.31 18.499-8.574 8.918-15.832-1.653-15.832-1.653-1.65-6.94.99-29.732.99-29.732s3.958-19.16 4.288-31.054c.33-11.894 4.286-14.866 4.286-14.866a106.052 106.052 0 0 1 15.489-34.27c1.993-2.86 3.31-4.384 3.31-4.384l53.43 6.278c-.857 1.717-1.624 4.178-2.297 7.089-3.473 14.947-4.626 41.806-4.626 41.806 12.205 7.935 15.831 29.405 15.831 29.405 0 5.617 8.578 26.434 8.578 26.434z'
      />

      <g
        fill='#000'
        fillRule='nonzero'
        opacity={0.05}
      >
        <path d='m338.339 157.973-.688-4.392s-27.108 35.6-26.777 43.183c.33 7.583-5.947 37.574-5.947 37.574-2.316 3.955-2.316 18.457-2.316 18.457-1.8 1.864-3.545 2.875-5.156 3.308 2.604.681 5.77.184 9.144-3.308 0 0 0-14.502 2.316-18.457 0 0 6.282-29.99 5.95-37.579-.279-5.93 16.273-29.026 23.474-38.786z' />

        <path d='M381.62 221.485s-3.635-21.422-15.868-29.336c0 0 1.156-26.794 4.636-41.713.68-2.905 1.44-5.355 2.304-7.073l-53.551-6.281s-.125.145-.352.428l49.94 5.84c-.858 1.714-1.628 4.169-2.302 7.073-3.48 14.915-4.636 41.714-4.636 41.714 12.228 7.926 15.863 29.348 15.863 29.348 0 5.604 8.594 26.37 8.594 26.37-1.362 1.749-6.518 2.237-10.523 2.344 3.175.081 12.572.111 14.489-2.344.004.005-8.594-20.766-8.594-26.37z' />
      </g>

      <path
        fill='#F7BBC3'
        fillRule='nonzero'
        d='M308.24 133.03a12.628 12.628 0 0 1-1.521 2.833c-1.93 2.771-5.938 6.44-13.28 5.436-1.099-.152-2.042-.908-2.486-1.99a3.56 3.56 0 0 1 .318-3.299c1.884-2.802 5-6.267 9.668-7.909a16.53 16.53 0 0 1 4.092-.89l3.209 5.819z'
      />

      <path
        fill='currentColor'
        fillRule='nonzero'
        d='m378.444 41.29-26.496-9.487s-7.6 3.88-4.624 9.377l25.765 15.846 5.355-15.737z'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='m378.444 41.29-26.496-9.487s-7.6 3.88-4.624 9.377l25.765 15.846 5.355-15.737z'
        opacity={0.1}
      />

      <path
        fill='#F7BBC3'
        fillRule='nonzero'
        d='M379.48 24.776s-.33 15.468 6.603 20.734c6.934 5.266-20.136 8.226-20.136 8.226s4.29-15.798 0-24.024 13.533-4.936 13.533-4.936z'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M371.862 143.278c-.862 1.696-1.633 4.125-2.31 6.998-32.067 4.815-54.386-8.303-54.386-8.303-.12-.19-.237-.377-.345-.564 2.004-2.823 3.327-4.327 3.327-4.327l53.714 6.196zm-62.525-10.165a12.656 12.656 0 0 1-1.6 2.872c-3.12-.532-5.619-6.672-6.079-7.871a17.87 17.87 0 0 1 4.304-.902l3.375 5.901z'
        opacity={0.1}
      />

      <path
        fill='currentColor'
        fillRule='nonzero'
        d='m381.543 38.383-11.884 4.266-4.952 6.567s-10.232 3.28-11.554 3.28c-1.321 0-4.951 1.315-7.264 6.567-2.312 5.252-10.559 30.846-17.823 35.113-7.264 4.266-26.408 32.852-26.408 32.852s3.3 8.861 7.264 7.551l9.242-7.551s-7.264 7.223-2.97 13.785c0 0 27.07 16.084 64.359 6.237l.33-9.847 1.652 7.876 18.514-11.502s-1.657-21.188-4.639-31.973a19.381 19.381 0 0 1 1.288-13.585c4.792-9.932 12.189-26.52 11.288-32.57-1.064-7.13-5.114-10.24-6.659-11.161a2.77 2.77 0 0 0-1.163-.384l-6.04-.602-12.58-4.92z'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M361.99 71.283s-6.67 30.766-14.005 35.728c-7.333 4.962-27.011 20.842-27.679 23.49'
        opacity={0.05}
      />

      <path
        fill='currentColor'
        fillRule='nonzero'
        d='M358.699 70.186s-6.67 30.76-14.004 35.72c-7.334 4.962-27.012 20.838-27.68 23.5'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M365.28 49.35s22.965-7.008 29.618-5.18'
        opacity={0.1}
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M396.708 88.3c4.713-9.968 11.986-26.616 11.1-32.687-1.046-7.155-5.029-10.277-6.548-11.201a2.686 2.686 0 0 0-1.143-.386l-2.532-.257c.265.065.518.17.751.313 1.52.942 5.485 4.046 6.548 11.201.886 6.067-6.387 22.719-11.1 32.687a19.816 19.816 0 0 0-1.266 13.633c2.954 10.824 4.561 32.088 4.561 32.088l-15.652 9.929.396 1.931 18.214-11.535s-1.629-21.263-4.561-32.088a19.816 19.816 0 0 1 1.232-13.628zm-5.455-45.203 2.814.283-12.227-4.899-1.097.403zM358.699 103.086s10.047-5.328 13.287-4.073c3.24 1.254 15.233-.314 15.233-.314m-8.837-69.939c-.38-3.384 1.159-2.87 1.159-2.87s-17.903-3.376-13.59 5.065c1.077 2.116 1.616 4.715 1.818 7.428h.169c5.006.004 7.906-5.663 10.444-9.622z'
        opacity={0.05}
      />

      <ellipse
        cx={367.474}
        cy={23.03}
        fill='#F7BBC3'
        fillRule='nonzero'
        rx={14.26}
        ry={14.257}
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M382.96 27.25c1.272-2.776 2.205-5.788 2.048-8.86-.157-3.07-1.526-6.146-4.07-7.85-1.314-.882-2.866-1.354-4.24-2.155-1.064-.63-2.005-1.443-3.018-2.152a17.171 17.171 0 0 0-17.077-1.236c-2.574 1.266-4.77 3.202-7.207 4.737-2.438 1.536-5.292 2.721-8.136 2.266-.488 1.35.712 2.683 1.819 3.607 2.098 1.75 4.477 3.497 7.207 3.556 1.06.025 2.175-.203 3.137.24a4.494 4.494 0 0 1 1.603 1.481 28.975 28.975 0 0 1 3.328 5.615c.364.814.738 1.687 1.492 2.18 1.272.802 2.896.136 4.388.077 2.323-.089 4.41 1.362 6.13 2.923 1.722 1.561 3.354 3.333 5.512 4.155 1.62.612 4.859.591 5.685-1.337.31-.725-.284-2.282-.16-3.172.228-1.405.966-2.78 1.56-4.075z'
        opacity={0.1}
      />

      <path
        fill='#9B6C7A'
        fillRule='nonzero'
        d='M382.96 26.153c1.272-2.776 2.205-5.788 2.048-8.859-.157-3.07-1.526-6.146-4.07-7.85-1.314-.882-2.866-1.355-4.24-2.156-1.064-.629-2.005-1.443-3.018-2.152A17.171 17.171 0 0 0 356.603 3.9c-2.574 1.266-4.77 3.202-7.207 4.738-2.438 1.535-5.292 2.72-8.136 2.265-.488 1.35.712 2.683 1.819 3.607 2.098 1.75 4.477 3.497 7.207 3.556 1.06.025 2.175-.202 3.137.24a4.494 4.494 0 0 1 1.603 1.481 28.975 28.975 0 0 1 3.328 5.615c.364.814.738 1.688 1.492 2.181 1.272.802 2.896.135 4.388.076 2.323-.089 4.41 1.363 6.13 2.923 1.722 1.561 3.354 3.333 5.512 4.156 1.62.611 4.859.59 5.685-1.338.31-.725-.284-2.282-.16-3.172.228-1.4.966-2.78 1.56-4.075z'
      />

      <path
        fill='currentColor'
        fillRule='nonzero'
        d='M289.592 247.844H65.816V107.472h28.618l11.774 14.605h183.384z'
      />

      <path
        fill='#A8A8A8'
        fillRule='nonzero'
        d='M78.98 262.545s-9.782-1.877-12.39-4.381c-2.61-2.505-14.346-6.885-15.65-3.744-1.305 3.14-17.605 13.77-6.501 15.65 11.103 1.881 26.08 2.497 29.344 1.249 3.264-1.248 5.197-8.774 5.197-8.774z'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M44.413 268.785c11.089 1.954 26.087 2.6 29.352 1.3 2.484-.992 4.209-5.762 4.89-7.985l.325.07s-1.955 7.824-5.202 9.124c-3.247 1.3-18.263.65-29.352-1.3-3.2-.563-4.114-1.889-3.772-3.57.26 1.1 1.374 1.941 3.759 2.361z'
        opacity={0.2}
      />

      <path
        fill='#A8A8A8'
        fillRule='nonzero'
        d='M278.622 280.042s-14.803-2.984-18.755-6.961c-3.951-3.977-21.713-10.938-23.686-5.965-1.974 4.973-26.658 21.876-9.89 24.86 16.769 2.985 39.48 3.977 44.416 1.989 4.936-1.988 7.915-13.923 7.915-13.923z'
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M226.304 290.032c16.77 3.042 39.483 4.053 44.42 2.026 3.758-1.545 6.372-8.963 7.404-12.411l.494.106s-2.962 12.146-7.907 14.186c-4.945 2.04-27.641 1.016-44.42-2.026-4.846-.883-6.23-2.941-5.706-5.546.421 1.7 2.107 3.011 5.715 3.665z'
        opacity={0.2}
      />

      <path
        fill='#000'
        fillRule='nonzero'
        d='M151.378 173.271h49.362v8.773h-49.362z'
        opacity={0.1}
      />
    </g>
  </svg>
)

export default IllustrationCases
